'use strict';

var storedFocusElement;

exports.storeFocus = function() {
  storedFocusElement = document.activeElement;
};

exports.clearStoredFocus = function() {
  storedFocusElement = null;
};

exports.restoreFocus = function() {
  if (!storedFocusElement) return;
  try { storedFocusElement.focus(); } catch (err) {}
  storedFocusElement = null;
};



//////////////////
// WEBPACK FOOTER
// ./~/a11y-focus-store/index.js
// module id = 7472
// module chunks = 2